import React, { useState } from 'react';
import '../styles/env.scss';

import CONTENT from '../constants/content';

function Env() {

  const [expanded, setExpanded] = useState(false);

  return (
    <div className="Env">
      <div className="container container-env">
        <p className="titleEnv">Environment</p>
        <p className="subtitleEnv">Respect our environment by questing.</p>
        <p className="textEnv">{expanded ? CONTENT.envMore : CONTENT.env}</p>
        <p onClick={() => setExpanded(!expanded)} className="readMoreEnv">
          {expanded ? "Read less <" : "Read more >"}
        </p>
      </div>
    </div>
  );
}

export default Env;
